var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: _vm.heightChart, width: '100%', position: 'relative' })},[_c(_vm.chartComponent,{tag:"component",staticStyle:{"height":"100%","width":"100%"},attrs:{"chart-data":_vm.datacollection,"options":_vm.chartOptions,"height":null,"width":null},on:{"chart-ready":function($event){return _vm.$emit('chart-ready', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }